import { Button, IconPlus } from '@gmg/gmg-react-components';
import { FunctionComponent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AppContext from 'src/AppContext';
import { default as IconKeyFilled } from '../../../assets/svg/icon_key_filled.svg';
import AddExistingLicenseSystemToOrgModalContainer from './AddExistingLicenseSystemToOrgModalContainer';

const AddExistingLicenseSystemToOrgButton: FunctionComponent<{}> = () => {
    const { t } = useTranslation();
    const context = useContext(AppContext);

    return (
        <Button
            variant='secondary'
            onClick={() => {
                context.onShowModal('inputModal', {
                    title: t('AddExistingLicenseSystemToOrg.modal_title', 'Add existing license system'),
                    titleIcon: <IconKeyFilled />,
                    content: <AddExistingLicenseSystemToOrgModalContainer />,
                });
            }}
            icon={<IconPlus/>}
        >
            {t('AddExistingLicenseSystemToOrg.button_title', 'Add existing system')}
        </Button>
    );
};

export default AddExistingLicenseSystemToOrgButton;